import account from './account'
import apikeys from './apikeys'
import approvals from './approvals'
import attachment from './attachment'
import audit from './audit'
import category from './category'
import challenge from './challenge'
import comment from './comment'
import country from './country'
import findings from './findings'
import like from './like'
import notification from './notification'
import organization from './organization'
import problemsolving from './problemsolving'
import quickaction from './quickaction'
import report from './report'
import rev from './rev'
import routine from './routine'
import reminder from './reminder'
import search from './search'
import site from './site'
import situationType from './situationType'
import signup from './signup'
import stream from './stream'
import translate from './translate'
import teams from './teams'
import webhooks from './webhooks'
import ideamatch from './ideamatch'
import bulkaccount from './bulkaccount'
import recognition from './recognition'
import explore from './explore'
import tag from './tag'
import checklist from './checklist'
import revchecklist from './revchecklist'
import validationRequest from './validationRequest'
import sitegroups from './sitegroups'
import metrics from './metrics'
import tagGroups from './taggroups'
import userFilter from './userfilter'
import tasks from './tasks'
import board from './board'
import subscription from './subscription'
import insights from './insights'
import integrations from './integrations'
import ai from './ai'
import powerpoint from './powerpoint'
import oauth from './oauth'
// AsyncComputed needs a promise to be resolved or rejected
// It does not accept a boolean result, therefore we need
// to return a wait statement for when we need to wait
const wait = function() {
  return new Promise(resolve => resolve(false))
}

const api = {
  account,
  oauth,
  ai,
  apikeys,
  approvals,
  attachment,
  audit,
  board,
  bulkaccount,
  category,
  challenge,
  checklist,
  comment,
  country,
  explore,
  findings,
  ideamatch,
  like,
  metrics,
  notification,
  organization,
  problemsolving,
  quickaction,
  recognition,
  report,
  rev,
  revchecklist,
  routine,
  search,
  site,
  sitegroups,
  situationType,
  signup,
  stream,
  tag,
  tagGroups,
  tasks,
  translate,
  teams,
  userFilter,
  validationRequest,
  wait,
  webhooks,
  subscription,
  reminder,
  insights,
  integrations,
  powerpoint,
}

export default api
